import { createCreateExpenseCategoryValidator, createUpdateExpenseCategoryValidator, } from "#validators/expense_categories.validator.factory";
// Use factory functions with pass-through translation for type inference
const createExpenseCategoryValidatorForType = createCreateExpenseCategoryValidator((key) => key);
const updateExpenseCategoryValidatorForType = createUpdateExpenseCategoryValidator((key) => key);
